var Flickity = require('flickity');

jQuery(function($) {

    function resizeFlickityTestimonial(timeline) {
        let children = timeline.find('.timeline-slide');
        let tallest = null;
        $(children).each(function (index) {
            let child = $(this);
            if (tallest == null || tallest.height() < child.height()) 
                tallest = child;
        });
        //select all other timeline-slide apart from the tallest
        let other_children = children.not(tallest);
        other_children.each(function (index) {
            let child = $(this);
            child.height(tallest.height());
        });
    }

    var timeline = $('.timeline-slide-wrapper');
    if (timeline.length) {
        var flkty = new Flickity( timeline[0], {
            // options
            cellAlign: 'left',
            contain: true,
            prevNextButtons: false,
            pageDots: false,
            groupCells: true,
            wrapAround: false,
            lazyLoad: true
        });
        window.onresize = function(event) { 
            flkty.resize(); 
            resizeFlickityTestimonial(timeline); 
        };
        resizeFlickityTestimonial(timeline)
    }

    var description_image = $('.description-image-slider-track');
    if (description_image.length) {
        var flkty = new Flickity( description_image[0], {
            // options
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            pageDots: true,
            groupCells: true,
            wrapAround: false,
            lazyLoad: true
        });
    }

    var testimonial = $('.testimonial-slide-wrapper:not(.single) .slide-rail .slides');
    if (testimonial.length) {
        var flkty = new Flickity( testimonial[0], {
            // options
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            pageDots: true,
            groupCells: true,
            wrapAround: false,
            lazyLoad: true
        });
        window.setTimeout(function(){
            flkty.resize();
        }, 300);
    }

    var case_studies = $('.case-study-slider-wrapper:not(.single) .case-study-slider');
    if (case_studies.length) {
        var flkty = new Flickity( case_studies[0], {
            // options
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            pageDots: true,
            groupCells: true,
            wrapAround: false,
            lazyLoad: true
        });
    }

});